<template>
    <div>
            <!-- Attention ici le lien (link n'est pas entre {{}}) MAIS v-bind:href="monLien.link" -->
            <!-- <div v-bind:style="{ color: activeColor, fontSize: fontSize + 'px' }">Mon div</div> OK -->
            <!-- <div v-bind:style="maClass">Mon div</div> OK -->

            <header>

                <nav id="navBar" :class="{sticky:active}"><div id="nav-container" :class="toggleNavClass()"></div>

                    <ul>
                        <li v-for="monLien in mesLiens" :key="monLien.numero">
                            <a v-bind:href="monLien.link" class="cool-link">{{monLien.description}}</a>
                        </li> 
                    </ul>
                </nav>
            </header>
    </div>
</template>

<script>
export default {
  name: 'menuV',
    data() {  // Menu  
      return   {

      active: false, // <- script NAV
             mesLiens : [

                {
                    numero: "1",
                    description : "Qui suis-je ?",
                    link : "#quiSuisJe",
                },
                {
                    numero: "2",
                    description : "Portfolio",
                    link : "#portfolio",
                },
                {
                    numero: "3",
                    description : "Contact",
                    link : "#contact",
                },
                    ]
             };    

        },

// script NAV

methods: {
    toggleNavClass(){
        if(this.active == false){
          return 'navBar'
        } else {
          return 'sticky-nav'
        }
    },
},

mounted(){
  window.document.onscroll = () => {
      let navBar = document.getElementById('navBar');
      if(window.scrollY > navBar.offsetTop){
        this.active = true;
        } else {
        this.active = false;
        }
      }
    }
// fin de script
};

</script>

<style scoped>

/*  scroll navBar */
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

/* quand j'ai les 2 sticky + content */
.sticky+.content {
  padding-top: 60px;
}

/*  nav */
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #306ea3;
}

li {
  display: inline-block;
}

li a {
  display: flex;
  align-content: center;
  color: white;
  text-align: center;
  margin: 14px 16px;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.6;  /* Opacité   */
  transition: 0.3s;
}

li a:hover {
  opacity: 1;
}

/* position de base */
#navBar {
  display: flex;
  justify-content: center;
  background-color: #306ea3;
  text-align: center;
  z-index: 3;
}

/* position de la NAV quand elle est fixée */
#navBar .sticky-nav{
  display: flex;
  justify-content: center;
  background-color: #306ea3;
  text-align: center;
  z-index: 3;
  position: fixed;
  top: 0; 
  }


.cool-link {
    display: inline-block;
    color: white;
    text-decoration: none;
}

.cool-link::after {
    content: '';
    display: block;
    width: 0;
    height: 1px;
    position: relative;
    top: 14px;
    background: white;
    transition: width .3s;
    padding: 0px;
}

.cool-link:hover::after {
    width: 100%;
    transition: width .3s;
    padding: 0px;
}
  
</style>


